<template>
  <form>
    <v-row>
      <v-col cols="12" sm="12" md="11" lg="11">
        <v-row>
          <v-col cols="4" sm="4" md="1" lg="1" class="py-0">
            <v-subheader>Month<span class="red--text">*</span></v-subheader>
          </v-col>
          <v-col cols="4" sm="4" md="2" lg="2" class="py-0">
            <v-select outlined flat dense background-color="white"></v-select>
          </v-col>
          <v-col cols="4" sm="4" md="1" lg="1" class="py-0">
            <v-text-field
              outlined
              flat
              v-model="form.year"
              dense
              background-color="white"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" sm="4" md="1" lg="1" class="py-0">
            <v-subheader>Type</v-subheader>
          </v-col>
          <v-col cols="8" sm="8" md="3" lg="3" class="py-0">
            <v-select outlined flat dense background-color="white"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-tabs vertical background-color="light-blue accent-3" dark class="px-0">
              <v-tab>
                <v-icon>
                  mdi-note-text
                </v-icon>
              </v-tab>
              <v-tab>
                <v-icon>
                  mdi-information
                </v-icon>
              </v-tab>
              <v-tab-item>
                <v-card flat class="px-2">
                  <v-row>
                    <v-col cols="6" class="pb-0">
                      <v-autocomplete
                        outlined
                        flat
                        dense
                        background-color="white"
                        placeholder="Find/Choose Account"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" align-self="start" class="text-right pb-0">
                      <p class="headline font-italic">
                        Budget Detail <span class="red--text">*</span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <v-data-table
                        :headers="headers"
                        :items="form.items"
                        disable-pagination
                        hide-default-footer
                      ></v-data-table>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2">
                      <v-subheader>Notes</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4">
                      <v-textarea outlined flat rows="3" background-color="white"></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" sm="4" md="2" lg="2">
                      <v-subheader>Analyst Name</v-subheader>
                    </v-col>
                    <v-col cols="8" sm="8" md="4" lg="4">
                      <v-text-field outlined flat dense background-color="white"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="1" lg="1">
        <v-row>
          <v-col cols="12" class="mb-4">
            <v-btn :color="unlock ? 'blue' : 'grey'">
              <v-icon large>
                mdi-content-save
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" class="mb-4">
            <v-btn color="amber darken-2">
              <v-icon large>
                mdi-printer
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </form>
</template>

<script>
// import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";

export default {
  //   mixins: [validationMixin],

  //   validations: {
  //     form: {
  //       accountNo: { required },
  //       name: { required }
  //     }
  //   },

  data: () => ({
    defaultForm: {
      month: null,
      year: new Date().getFullYear().toString(),
      type: null,
      note: "",
      analysName: "",
      items: [
        { name: "produk 1", code: "RT125", budget: "10000" },
        { name: "produk 2", code: "RT126", budget: "10000" },
        { name: "produk 3", code: "RT127", budget: "10000" },
        { name: "produk 4", code: "RT128", budget: "10000" },
      ],
    },
    unlock: false,
    form: {},
    headers: [
      {
        text: "Expense/Income",
        value: "name",
        sortable: false,
        width: "70%",
        divider: true,
      },
      {
        text: "Code",
        value: "code",
        sortable: false,
        width: "15%",
        divider: true,
      },
      {
        text: "Budget",
        value: "budget",
        sortable: false,
        divider: true,
        width: "15%",
      },
    ],
  }),

  computed: {},

  watch: {
    form: {
      handler() {
        this.unlock = true;
      },
    },
  },

  methods: {
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        for (let key in Object.keys(this.$v.form)) {
          const input = Object.keys(this.$v.form)[key];
          if (input.includes("$")) return false;
          if (this.$v.form[input].$error) {
            this.$refs[input].focus();
            break;
          }
        }
      } else {
        console.log(this.form);
      }
    },
    clear() {
      this.$v.form.$reset();
      this.form = Object.assign({}, this.defaultForm);
    },
  },

  mounted() {
    this.form = Object.assign({}, this.defaultForm);
  },
};
</script>

<style></style>
